// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1fTLf","title":"Header_title__3C9Cm","left":"Header_left__1EmMf","clinicName":"Header_clinicName__2fXmz"};